function Mapimg({ fill, height, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
    >
      <g
        id="Map_bleue"
        data-name="Map bleue"
        transform="translate(16753 -19512)"
      >
        <rect
          id="Rectangle_4350"
          data-name="Rectangle 4350"
          width="30"
          height="30"
          transform="translate(-16753 19512)"
          fill="none"
        />
        <g
          id="Groupe_4236"
          data-name="Groupe 4236"
          transform="translate(-16752.941 19513.77)"
        >
          <path
            id="Tracé_2972"
            data-name="Tracé 2972"
            d="M84.422,195.87,75.4,192.721,81.59,179.5l5.14.933Z"
            transform="translate(-75.4 -169.412)"
            fill="#fff"
          />
          <path
            id="Tracé_2973"
            data-name="Tracé 2973"
            d="M183.7,195.87l9.531-3.166-1.8-13.2-5.423.933Z"
            transform="translate(-174.678 -169.412)"
            fill="#e6e9ee"
          />
          <path
            id="Tracé_2974"
            data-name="Tracé 2974"
            d="M289.688,195.87,278.3,192.7l-1.8-13.2,5.7.933Z"
            transform="translate(-259.747 -169.412)"
            fill="#fff"
          />
          <g
            id="Groupe_334"
            data-name="Groupe 334"
            transform="translate(2.458 11.696)"
          >
            <path
              id="Tracé_2975"
              data-name="Tracé 2975"
              d="M283.007,199.516,279.1,198.8l1.266,9.306,7.306,1.958Z"
              transform="translate(-264.587 -198.8)"
              fill="#a8caff"
            />
            <path
              id="Tracé_2976"
              data-name="Tracé 2976"
              d="M109.482,201.3,104.9,211.331l6.856,2.124,1.75-11.43Z"
              transform="translate(-104.9 -201.092)"
              fill="#a8caff"
            />
          </g>
          <path
            id="Tracé_2977"
            data-name="Tracé 2977"
            d="M194.856,198.8l-5.907.933-1.75,11.43,8.922-3.057Z"
            transform="translate(-177.886 -187.103)"
            fill="#75a8fb"
          />
          <path
            id="Exclusion_1"
            data-name="Exclusion 1"
            d="M6.791,18.727v0c-.016-.021-1.715-2.071-3.4-4.56C1.846,11.868,0,8.724,0,6.788a6.789,6.789,0,0,1,13.578,0c0,1.936-1.845,5.08-3.393,7.376-1.684,2.5-3.377,4.54-3.393,4.56ZM6.783,2.793a3.439,3.439,0,1,0,3.441,3.442A3.445,3.445,0,0,0,6.783,2.793Z"
            transform="translate(7.78 0)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

export default Mapimg;
